import { render, staticRenderFns } from "./VisitShopDetail.vue?vue&type=template&id=b49b1634&scoped=true&"
import script from "./VisitShopDetail.vue?vue&type=script&lang=js&"
export * from "./VisitShopDetail.vue?vue&type=script&lang=js&"
import style0 from "./VisitShopDetail.vue?vue&type=style&index=0&id=b49b1634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49b1634",
  null
  
)

export default component.exports